import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Renderer2
} from '@angular/core';
import {Store} from '@ngrx/store';
import {CommonService} from "./modules/shared/services/common.service";
import {pairwise, Subject, Subscription, takeUntil} from "rxjs";
import {
  FetchLatestNotificationForPopupRequest,
  FetchNotificationDetailsRequest,
  SetScreenSize,
  SetScreenType
} from "./modules/shared/core/shared.actions";
import {BreakpointObserver, Breakpoints} from "@angular/cdk/layout";
import * as fromRoot from "src/app/state/app.state";
import {
  LastFetchedNotificationTimeStamp,
  screenSize
} from "./modules/shared/core/shared.selectors";
import * as $ from "jquery";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router, RoutesRecognized
} from "@angular/router";
import {MatDialog} from '@angular/material/dialog';
import {
  NotificationDetailsPopupComponent
} from "./modules/shared/components/notification-details-popup/notification-details-popup.component";
import moment from 'moment';
import {MessageService} from 'primeng/api';
import {
  NotificationConfig
} from './modules/shared/constants/notification.config';
import {
  OpenNotificationConfirmationPopupComponent
} from './modules/shared/components/open-notification-confirmation-popup/open-notification-confirmation-popup.component';

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent implements OnInit, OnDestroy {
  title = "Stanford";

  isLoadingSubscription: Subscription;
  isLoadingScreenOpenSubscription: Subscription;
  isLoadingScreenOpen = false;
  lastNotificationPopupTimestamp: any;
  notificationConfig = NotificationConfig
  breakpointObserverSubscription: Subscription = this.breakpointObserver.observe([
    Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium,
    Breakpoints.Large, Breakpoints.XLarge
  ]).subscribe((result) => {

    this.clearBodySizeClasses();

    if (this.breakpointObserver.isMatched(Breakpoints.XSmall)) {
      this.store.dispatch(SetScreenType({screenType: "mobile"}));
      this.store.dispatch(SetScreenSize({screenSize: "xs"}));
    } else if (this.breakpointObserver.isMatched(Breakpoints.Small)) {
      this.store.dispatch(SetScreenType({screenType: "mobile"}));
      this.store.dispatch(SetScreenSize({screenSize: "sm"}));
    } else if (this.breakpointObserver.isMatched(Breakpoints.Medium)) {
      this.store.dispatch(SetScreenType({screenType: "tablet"}));
      this.store.dispatch(SetScreenSize({screenSize: "md"}));
    } else if (this.breakpointObserver.isMatched(Breakpoints.Large)) {
      this.store.dispatch(SetScreenType({screenType: "desktop"}));
      this.store.dispatch(SetScreenSize({screenSize: "lg"}));
    } else if (this.breakpointObserver.isMatched(Breakpoints.XLarge)) {
      this.store.dispatch(SetScreenType({screenType: "desktop"}));
      this.store.dispatch(SetScreenSize({screenSize: "xl"}));
    }

    this.commonService.closeDialog();
  });
  private readonly onDestroy: Subject<any> = new Subject<any>();

  prevUrl = '';

  constructor(
    private store: Store<fromRoot.State>,
    private breakpointObserver: BreakpointObserver,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private route: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private messageService: MessageService,
    private renderer: Renderer2
  ) {
    this.router.events
      .pipe(takeUntil(this.onDestroy))
      .subscribe(value => {
        if (value instanceof NavigationEnd) {
          console.log('Navigation has ended');

          let currentUrl = value.url;
          let isRouteChanged = false;
           if (this.prevUrl !== currentUrl) {
             isRouteChanged = true;
             this.prevUrl = currentUrl;
           }

          this.commonService.onNavigationEnd.next({...value, isRouteChanged});
          if (this.router.url.includes('step-warning')) {
            return;
          }

          if (this.commonService.isAuthenticated() && !this.commonService.getOnboardingToken() && router.url !== '/download-expired') {
            this.store.dispatch(FetchLatestNotificationForPopupRequest({
              payload: {
                ...(this.lastNotificationPopupTimestamp ? {
                  timestamp: moment(this.lastNotificationPopupTimestamp)
                    .toISOString()
                } : {})
              }
            }))
          }
        }
      });

    this.store.select(screenSize).pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        $("body").addClass(data);
      });
  }

  ngOnInit() {
    const r = this.router;
    window.addEventListener('storage', function(e) {
      // Some storage value changed. Reload tab!
      if (e.key === 'ss-cord/token' && r.url.includes('auth')) {
        window.location.reload();
      }

      if (e.storageArea['ss-cord/token'] === undefined) {
        window.location.reload();
      }
    });
    this.isLoadingScreenOpenSubscription = this.commonService.isLoadingScreenOpen.subscribe(data => {
      this.isLoadingScreenOpen = data
      this.cdRef.detectChanges();
    });
    this.route.queryParamMap.pipe(takeUntil(this.onDestroy))
      .subscribe((queryParams: any) => {
        if (queryParams.params?.notificationId) {
          const params = {...queryParams.params}
          this.store.dispatch(FetchNotificationDetailsRequest({payload: {notificationId: queryParams.params?.notificationId}}))
          const detailsNotificationDialog = this.commonService.openDialog({
            data: {
              component: NotificationDetailsPopupComponent,
              data: {queryParams: {...queryParams.params}}
            }
          })
          detailsNotificationDialog.afterClosed()
            .pipe(takeUntil(this.onDestroy)).subscribe(closed => {
            delete params.notificationId
            const currentRoute = this.router.url.split('?');
            this.router.navigate([`${currentRoute[0]}`], {queryParams: params});
          })
        }
      })

    this.store.select(LastFetchedNotificationTimeStamp)
      .pipe(takeUntil(this.onDestroy)).pipe(takeUntil(this.onDestroy))
      .subscribe(notificationTimeStamp => {
        this.lastNotificationPopupTimestamp = notificationTimeStamp
      })
  }

  clearBodySizeClasses() {
    const body = $("body");
    body.removeClass("xs");
    body.removeClass("sm");
    body.removeClass("md");
    body.removeClass("lg");
    body.removeClass("xl");
  }

  openNotificationDetails() {
    const isConfirmationNeeded = this.notificationConfig.map(route => this.router.url.includes(route))
    if (isConfirmationNeeded.some(isNeeded => isNeeded === true)) {
      this.confirmationPopup();
    } else {
      this.navigateToNotificationCenter();
    }
  }

  confirmationPopup() {
    const dialog = this.dialog.open(OpenNotificationConfirmationPopupComponent);
    dialog.afterClosed().pipe(takeUntil(this.onDestroy)).subscribe(data => {
      if (data.navigate) {
        this.navigateToNotificationCenter()
      }
    })
  }

  navigateToNotificationCenter() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/notifications`]);
    this.messageService.clear();
  }

  ngAfterViewInit() {
    let loader = this.renderer.selectRootElement('#loader');
    this.renderer.setStyle(loader, 'display', 'none');
  }

  ngOnDestroy() {
    this.isLoadingSubscription?.unsubscribe();
    this.breakpointObserverSubscription?.unsubscribe();
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
